import { render, staticRenderFns } from "./SpcmCounsellorEdit.vue?vue&type=template&id=685e34ee&scoped=true"
import script from "./SpcmCounsellorEdit.vue?vue&type=script&lang=js"
export * from "./SpcmCounsellorEdit.vue?vue&type=script&lang=js"
import style0 from "./SpcmCounsellorEdit.vue?vue&type=style&index=0&id=685e34ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e34ee",
  null
  
)

export default component.exports